module.exports = "<app-main></app-main>"